import { render, staticRenderFns } from "./TaleModal.vue?vue&type=template&id=42eb4ebd&"
import script from "./TaleModal.vue?vue&type=script&lang=js&"
export * from "./TaleModal.vue?vue&type=script&lang=js&"
import style0 from "./TaleModal.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports